import { Fragment, useEffect } from 'react';
import PropertiesFormDependentSection from './PropertiesFormDependentSection';
import useNewPropertiesForm from './useNewPropertiesForm';
import { PropertiesProvider } from '../context/PropertiesProvider';
import { useStableFunction } from '../utils/hooks/useStableFunction';
import { getIsPropertyInput } from '../utils/getInputFieldType';
import { useGetIsUngatedForConditionalAssociations } from '../v2/hooks/useGetIsUngatedForConditionalAssociations';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function NewPropertiesForm({
  onStatusChange: onStatusChangeUnstable,
  enableAutosave = false,
  enableDependentAssociations = false,
  enableFieldLevelPermissions = true,
  alwaysShowConditionalProperties,
  alwaysShowConditionalPropertyOptionsWithErrors,
  fetchConditionalPropertyRules,
  inputMode,
  objectId,
  objectTypeId,
  onChange,
  onAssociationChange,
  onPropertyLeavesForm,
  onSave,
  properties,
  values,
  associationValues,
  renderInput,
  renderDependentSection,
  renderProps,
  resetRef,
  showPropertyDescription,
  getSavedValue
}) {
  const hasDependentAssociationsAccess = useGetIsUngatedForConditionalAssociations({
    enableDependentAssociations
  });
  const {
    inputs,
    status,
    reset
  } = useNewPropertiesForm({
    alwaysShowConditionalProperties,
    alwaysShowConditionalPropertyOptionsWithErrors,
    enableAutosave,
    enableDependentAssociations: hasDependentAssociationsAccess,
    fetchConditionalPropertyRules,
    inputMode,
    objectId,
    objectTypeId,
    onChange,
    onAssociationChange,
    onPropertyLeavesForm,
    onSave,
    properties,
    values,
    associationValues,
    showPropertyDescription,
    getSavedValue
  });
  if (resetRef) {
    resetRef.current = reset;
  }
  const onStatusChange = useStableFunction(onStatusChangeUnstable);
  useEffect(() => {
    onStatusChange(status);
  }, [status, onStatusChange]);
  const passthroughProps = Object.assign({}, renderProps);
  function renderDependents(dependents, path) {
    if (!dependents) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: dependents.map(dependent => {
        const isPropertyInput = getIsPropertyInput(dependent);
        const name = isPropertyInput ? dependent.property.name : dependent.fieldName;
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            "data-test-id": `${path}-${name}`,
            children: isPropertyInput ? renderInput ? renderInput(dependent) : dependent.render(passthroughProps) : dependent.render()
          }), renderDependents(dependent.dependents, `${path}-${name}`)]
        }, `${path}-${name}`);
      })
    });
  }
  return /*#__PURE__*/_jsx(PropertiesProvider, {
    enableFieldLevelPermissions: enableFieldLevelPermissions,
    children: inputs.map(input => {
      // associations currently are not supported as controlling
      if (!getIsPropertyInput(input)) {
        return null;
      }
      const propertyInput = input;
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          "data-test-id": propertyInput.property.name,
          children: renderInput ? renderInput(propertyInput) : propertyInput.render(passthroughProps)
        }), propertyInput.dependents.length > 0 && (renderDependentSection ? renderDependentSection(propertyInput, passthroughProps) : /*#__PURE__*/_jsx(PropertiesFormDependentSection, {
          property: propertyInput.property,
          enableDependentAssociations: enableDependentAssociations,
          children: renderDependents(propertyInput.dependents, propertyInput.property.name)
        }))]
      }, propertyInput.property.name);
    })
  });
}